import '.ee{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.ef{padding-left:1.5rem;}.ssr-plugin'
import '.eg{margin:1rem 0;}.ssr-plugin'
import '.eh{color:var(--gray-700);}.ssr-plugin'
import '.ei{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="ee ef eg eh ei"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
